module.exports = __webpack_public_path__ + "static/media/CutMonoCroped.b5e97e09.png";